import { Breakpoint } from './breakpoint';
export const isBreakpointMobile = (breakpoint) => breakpoint <= Breakpoint.sm;
